// src/router/domains.ts
// Rotas do módulo de Gestão de Domínios (ITAM)
// NOTA: estas rotas são filhas do parent /itam definido em assets.ts

import type { RouteRecordRaw } from 'vue-router';

const domainsChildRoutes: RouteRecordRaw[] = [
    {
        path: 'domains',
        name: 'itam-domains',
        component: () => import('@/views/Assets/DomainsDashboard.vue'),
        meta: { title: 'Gestão de Domínios' }
    }
];

export default domainsChildRoutes;
